module.exports = __webpack_public_path__ + "img/凯吉.png";